import {useState, useEffect} from 'react';
import {useAppearance, useUserInfo} from '../../services';

export const useUserAppearance = () => {
  const [appearance, setAppearance] = useState<'day' | 'night'>('day');
  const [setting, setSetting] = useState<'day' | 'night' | 'auto'>('day');
  const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');
  const userInfo = useUserInfo();

  const settings = useAppearance(userInfo ? userInfo.userid : 0);

  useEffect(() => {
    if (settings === 'Auto') {
      if (prefersDarkScheme.matches) {
        setAppearance('night');
      } else {
        setAppearance('day');
      }
    } else if (settings === 'Night') {
      setAppearance('night');
    } else {
      setAppearance('day');
    }
  }, [prefersDarkScheme, setting, settings]);
  return {darkmode: appearance, setSetting};
};
